module.exports = __webpack_public_path__ + "img/Pr22.8b38570f.png";